export const categories: any = [{
    "id": 1,
    "icon": null,
    "name": "Xe m\u00e1y",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 1,
        "category_id": 1,
        "language_id": 1,
        "name": "Xe m\u00e1y",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 2,
        "category_id": 1,
        "language_id": 2,
        "name": "Motorbike",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 3,
        "category_id": 1,
        "language_id": 3,
        "name": "\uc624\ud1a0\ubc14\uc774",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 2,
    "icon": null,
    "name": "\u00d4 t\u00f4",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 4,
        "category_id": 2,
        "language_id": 1,
        "name": "\u00d4 t\u00f4",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 5,
        "category_id": 2,
        "language_id": 2,
        "name": "Car",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 6,
        "category_id": 2,
        "language_id": 3,
        "name": "\uc790\ub3d9\ucc28",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 3,
    "icon": null,
    "name": "C\u00e0 v\u1eb9t \u00f4 t\u00f4",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 7,
        "category_id": 3,
        "language_id": 1,
        "name": "C\u00e0 v\u1eb9t \u00f4 t\u00f4",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 8,
        "category_id": 3,
        "language_id": 2,
        "name": "Car parrot",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 9,
        "category_id": 3,
        "language_id": 3,
        "name": "\uc790\ub3d9\ucc28 \uc18c\uc720 \uc99d\uba85\uc11c",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 4,
    "icon": null,
    "name": "\u0110i\u1ec7n tho\u1ea1i",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 10,
        "category_id": 4,
        "language_id": 1,
        "name": "\u0110i\u1ec7n tho\u1ea1i",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 11,
        "category_id": 4,
        "language_id": 2,
        "name": "Phone",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 12,
        "category_id": 4,
        "language_id": 3,
        "name": "\ud734\ub300\ud3f0",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 5,
    "icon": null,
    "name": "M\u00e1y t\u00ednh",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 13,
        "category_id": 5,
        "language_id": 1,
        "name": "M\u00e1y t\u00ednh",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 14,
        "category_id": 5,
        "language_id": 2,
        "name": "Laptop",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 15,
        "category_id": 5,
        "language_id": 3,
        "name": "\ucef4\ud4e8\ud130",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 6,
    "icon": null,
    "name": "M\u00e1y t\u00ednh b\u1ea3ng",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 16,
        "category_id": 6,
        "language_id": 1,
        "name": "M\u00e1y t\u00ednh b\u1ea3ng",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 17,
        "category_id": 6,
        "language_id": 2,
        "name": "Tablet",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 18,
        "category_id": 6,
        "language_id": 3,
        "name": "\ud0dc\ube14\ub9bf",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 7,
    "icon": null,
    "name": "M\u00e1y \u1ea3nh",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 19,
        "category_id": 7,
        "language_id": 1,
        "name": "M\u00e1y \u1ea3nh",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 20,
        "category_id": 7,
        "language_id": 2,
        "name": "Camera",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 21,
        "category_id": 7,
        "language_id": 3,
        "name": "\uc0ac\uc9c4\uae30",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 8,
    "icon": null,
    "name": "\u0110\u1ed3ng h\u1ed3",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 22,
        "category_id": 8,
        "language_id": 1,
        "name": "\u0110\u1ed3ng h\u1ed3",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 23,
        "category_id": 8,
        "language_id": 2,
        "name": "Watch",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 24,
        "category_id": 8,
        "language_id": 3,
        "name": "\uc2dc\uacc4",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 9,
    "icon": null,
    "name": "Trang s\u1ee9c",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 25,
        "category_id": 9,
        "language_id": 1,
        "name": "Trang s\u1ee9c",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 26,
        "category_id": 9,
        "language_id": 2,
        "name": "Jewelry",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 27,
        "category_id": 9,
        "language_id": 3,
        "name": "\uc545\uc138\uc0ac\ub9ac",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 10,
    "icon": null,
    "name": "Nh\u00e0 \u0111\u1ea5t",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 28,
        "category_id": 10,
        "language_id": 1,
        "name": "Nh\u00e0 \u0111\u1ea5t",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 29,
        "category_id": 10,
        "language_id": 2,
        "name": "Real estate",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 30,
        "category_id": 10,
        "language_id": 3,
        "name": "\ubd80\ub3d9\uc0b0",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 11,
    "icon": null,
    "name": "Gi\u1ea5y t\u1edd c\u00e1c lo\u1ea1i",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 31,
        "category_id": 11,
        "language_id": 1,
        "name": "Gi\u1ea5y t\u1edd c\u00e1c lo\u1ea1i",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 32,
        "category_id": 11,
        "language_id": 2,
        "name": "All types of documents",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 33,
        "category_id": 11,
        "language_id": 3,
        "name": "\ubb38\uc11c",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}, {
    "id": 12,
    "icon": null,
    "name": "Kh\u00e1c",
    "parent_id": null,
    "sort": 0,
    "created_at": "2024-01-30 05:49:11",
    "updated_at": "2024-01-30 05:49:11",
    "deleted_at": null,
    "translations": [{
        "id": 34,
        "category_id": 12,
        "language_id": 1,
        "name": "Kh\u00e1c",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 1,
            "code": "vi",
            "name": "Ti\u1ebfng Vi\u1ec7t",
            "flag_icon": null,
            "created_at": "2023-12-22 05:45:54",
            "updated_at": "2023-12-22 05:45:54"
        }
    }, {
        "id": 35,
        "category_id": 12,
        "language_id": 2,
        "name": "Other",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 2,
            "code": "en",
            "name": "English",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }, {
        "id": 36,
        "category_id": 12,
        "language_id": 3,
        "name": "\uae30\ud0c0",
        "created_at": "2024-01-30 05:49:11",
        "updated_at": "2024-01-30 05:49:11",
        "language": {
            "id": 3,
            "code": "ko",
            "name": "Korean",
            "flag_icon": null,
            "created_at": "2024-01-29 07:27:21",
            "updated_at": "2024-01-29 07:27:21"
        }
    }]
}]